/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';

export default {
  async fetchPersonaPrivileges ({ commit, dispatch }, payload) {
    return new Promise(async (resolve) => {
      try {
        const privileges = await  this._vm.$api.orionPersonas.privileges();
        const privilegesData = privileges.data.data;

        commit('SET_PRIVILEGES', privilegesData);

        resolve(privilegesData);
      } catch(e) {
        console.log(e);
      }
    })
  },
  async setIsSystem ({ commit, dispatch }, payload) {
    return new Promise(async (resolve) => {
      try {
        const system = await this._vm.$api.orionPersonas.isSystem();
        const isSystem = system.data.data

        commit('SET_IS_SYSTEM', isSystem);

        resolve(isSystem);
      } catch(e) {
        console.log(e);
      }
    })
  },
}
